import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useEffect, useMemo, useState} from 'react';
import {getProductPageViewMainData} from 'modules/product-card/analytics/gtag/helpers';
import {EventAction, EventCategory, EventNames, EventPortalName} from 'modules/google-analytics/constants';
import {useGtagUserData} from 'hooks/analytics/gtag/helpers/useGtagUserData';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

export const useViewPDPGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    const [isSent, setIsSent] = useState(false);

    const product = useAppSelector(selectProductData);

    const gtagUserData = useGtagUserData({});

    const resultData = useMemo(() => {
        if (!product) {
            return;
        }
        // eslint-disable-next-line consistent-return
        return {
            ...gtagUserData,
            ...getProductPageViewMainData(product, eventLocation),
            event: EventNames.OWOX,
            eventCategory: EventCategory.Interactions,
            eventAction: EventAction.PageView,
            portalName: EventPortalName.Product,
        };
    }, [eventLocation, gtagUserData, product]);

    useEffect(() => {
        if (isSent || !resultData) {
            return;
        }

        sendGtagEvent(resultData);
        setIsSent(true);
    }, [isSent, resultData]);
};

export const usePDPReviewsViewGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    const [isSent, setIsSent] = useState(false);

    const product = useAppSelector(selectProductData);

    const gtagUserData = useGtagUserData({});

    const resultData = useMemo(() => {
        if (!product) {
            return;
        }

        // eslint-disable-next-line consistent-return
        return {
            ...gtagUserData,
            ...getProductPageViewMainData(product, eventLocation),
            event: EventNames.OWOX,
            eventCategory: EventCategory.Interactions,
            eventAction: EventAction.PageView,
            portalName: EventPortalName.ProductReview,
        };
    }, [eventLocation, gtagUserData, product]);

    useEffect(() => {
        if (isSent || !resultData) {
            return;
        }

        sendGtagEvent(resultData);
        setIsSent(true);
    }, [isSent, resultData]);
};
